import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, CircularProgress, Button } from '@material-ui/core';
import DownloadImage from '../../../../../../../../../assets/images/downloadGallery.png';
import DownloadService from '../../../../../../services/downloadAndZipService';

const styles = {
  logoEnable: {
    maxHeight: '25px',
  },
  logoDisabled: {
    maxHeight: '25px',
    opacity: '20%',
    cursor: 'not-allowed',
  },
  downloadProgress: {
    marginLeft: '10px',
    maxHeight: '20px',
  },
  textEnable: {
    color: '#ea0000',
    margin: 12,
  },
  textDisabled: {
    color: '#808080',
    margin: 12,
    cursor: 'not-allowed',
  },
  iconButtonStyle: {
    maxWidth: '40px',
    maxHeight: '40px',
    minWidth: '40px',
    minHeight: '40px',
  },
  textButtonStyle: {
    maxWidth: '70px',
    maxHeight: '25px',
    minWidth: '70px',
    minHeight: '25px',
  },
};

class DownloadAndZipPhotosButton extends React.PureComponent {
  state = {
    isDownloading: false,
  };

  handleOnClick = async () => {
    const { photoFolders, campaignId } = this.props;
    try {
      this.setState({ isDownloading: true });
      await DownloadService.downloadAndZipPhotos(photoFolders, campaignId);
    } catch (error) {
      alert(error.message);
    }
    this.setState({ isDownloading: false });
  };

  render() {
    const { tooltip, photoFolders, showIcon } = this.props;
    const { isDownloading } = this.state;

    return (
      <>
        <Tooltip testid="downloadPhotoByVisitIconTooltip" title={tooltip}>
          <Button
            testid="downloadPhotosButton"
            style={showIcon ? styles.iconButtonStyle : styles.textButtonStyle}
            onClick={this.handleOnClick}
            disabled={isDownloading || !photoFolders}
          >
            {showIcon ? (
              <img
                src={DownloadImage}
                alt="download_icon"
                style={isDownloading ? styles.logoDisabled : styles.logoEnable}
                testid="downloadPhotoButtonImage"
              />
            ) : (
              <span
                style={isDownloading ? styles.textDisabled : styles.textEnable}
                testid="downloadPhotoButtonText"
              >
                {isDownloading ? `Zipping` : `Download`}{' '}
              </span>
            )}
          </Button>
        </Tooltip>
        {isDownloading ? (
          <CircularProgress
            size={20}
            style={styles.downloadProgress}
            testid="downloadInProgressAnimation"
          />
        ) : null}
      </>
    );
  }
}

DownloadAndZipPhotosButton.propTypes = {
  tooltip: PropTypes.string.isRequired,
  photoFolders: PropTypes.shape({
    folders: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        photoUrls: PropTypes.arrayOf(PropTypes.string),
      }),
    ),
  }).isRequired,
  campaignId: PropTypes.string.isRequired,
  showIcon: PropTypes.bool.isRequired,
};

export default DownloadAndZipPhotosButton;
